import { render } from "./HandoverApproval.vue?vue&type=template&id=1a192308"
import script from "./HandoverApproval.vue?vue&type=script&lang=js"
export * from "./HandoverApproval.vue?vue&type=script&lang=js"

import "./HandoverApproval.vue?vue&type=style&index=0&id=1a192308&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__